import React from 'react'

type Props = React.SVGProps<SVGSVGElement>

const BenefitsShape: React.FC<Props> = props => (
  <svg
    width="452.9"
    height="369.6"
    viewBox="0 0 647 528"
    fill="none"
    {...props}>
    <path
      d="M0 289.5C0 157.78 106.78 51 238.5 51H647V528H238.5C106.78 528 0 421.22 0 289.5Z"
      fill="#EFF7E4"
    />
    <path
      d="M37 226.003 285.718 184l27.619 163.541-248.719 42.003L37 226.003Z"
      fill="#fff"
    />
    <g stroke="#CEDC00" strokeWidth="3.46">
      <path d="M294.167 329.791 196.119 255.201" />
      <path d="M81.616 365.686 149.732 263.034" />
    </g>
    <path
      d="M172.624 292.458 37 226.003 285.718 184 172.624 292.458Z"
      fill="#46AD06"
    />
    <g stroke="#78BE20" strokeWidth="3.46">
      <path d="M396.813 217.463 409.717 154.855c3.274-15.887 18.807-26.111 34.694-22.837 15.887 3.275 26.112 18.808 22.837 34.695l-12.904 62.608" />
      <path d="M361.678 199.638 374.582 137.03c3.275-15.886 18.808-26.111 34.695-22.836 15.887 3.274 26.111 18.807 22.837 34.694l-12.904 62.608" />
    </g>
    <path
      d="M225.341 429.079 320.177 169.915 502.924 207.58 507.043 487.14 225.341 429.079Z"
      fill="#fff"
    />
    <path
      d="m456.28 476.679 34.798-271.536 11.845 2.441 4.12 279.559-50.763-10.464Z"
      fill="#C4C4C4"
    />
    <path
      d="m436.699 349.163-138.752-28.598 86.556-49.191 52.196 77.789Z"
      fill="#72BF44"
    />
    <g fill="#FFA300">
      <path d="m531.88 63.32-.657 6.726c-.378 3.875 1.593 7.602 5.009 9.47l5.928 3.243-6.725-.657c-3.875-.378-7.602 1.593-9.471 5.009l-3.243 5.929.657-6.725c.378-3.875-1.593-7.602-5.008-9.47l-5.929-3.243 6.726.657c3.875.378 7.601-1.593 9.47-5.009l3.586-6.93Z" />
      <path d="m365.767 34.384.722 4.745c.415 2.734 2.422 4.956 5.099 5.646l4.648 1.198-4.745.721c-2.734.416-4.956 2.423-5.646 5.1l-1.199 4.647-.721-4.744c-.415-2.734-2.422-4.956-5.1-5.647l-4.647-1.198 4.745-.721c2.733-.415 4.955-2.422 5.646-5.099l1.198-4.647Z" />
      <path d="m466.296 15.094-.946 4.705c-.545 2.711.581 5.486 2.86 7.051l3.957 2.716-4.705-.946c-2.711-.545-5.486.581-7.051 2.861l-2.716 3.956.946-4.705c.545-2.711-.581-5.486-2.86-7.051l-3.957-2.716 4.705.946c2.711.545 5.486-.581 7.051-2.861l2.716-3.956Z" />
    </g>
    <g stroke="#FFA300" strokeWidth="2" strokeLinecap="round">
      <path d="M440.77 173.715c8.596-27.667 33.205-83.822 62.877-87.1" />
      <path d="M399.814 134.643c-.956-20.468-6.313-63.502-19.386-71.894" />
      <path d="M432.401 112.771c.82-17.188 5.294-53.431 16.635-60.895" />
    </g>
  </svg>
)

export default React.memo(BenefitsShape)
